import React from 'react'

import NowPlaying from './NowPlaying'
import RoutinePlaylist from './RoutinePlaylist'
import { getCategoryArtwork, getRoutineTrackLabel } from './routinePresentation'
import { useRoutinePlayer } from './useRoutinePlayer'

import { PlayerGrid } from './styles'

import type {
  RoutineCategory,
  RoutineCategoryOption,
  RoutinePlaylistItem,
} from './types'

interface RoutinePlayerProps {
  routines: RoutineCategory[]
}

const RoutinePlayer = ({ routines }: RoutinePlayerProps) => {
  const player = useRoutinePlayer(routines)
  const currentArtwork = getCategoryArtwork(
    player.playbackRoutine?.category ?? '',
  )
  const browsedArtwork = getCategoryArtwork(
    player.browsedRoutine?.category ?? '',
  )
  const categories: RoutineCategoryOption[] = player.availableRoutines.map(
    (routine, index) => ({
      id: routine.category,
      index,
      label: routine.category,
      active: index === player.browseCategoryIndex,
    }),
  )
  const playlistItems: RoutinePlaylistItem[] = player.browsedTracks.map(
    (track, index) => ({
      id: `${player.browsedRoutine?.category ?? 'routine'}-${track.logUID}-${index}`,
      index,
      label: getRoutineTrackLabel(track.title),
      category: player.browsedRoutine?.category ?? '',
      artwork: browsedArtwork,
      playing: player.isTrackPlaying(player.browseCategoryIndex, index),
    }),
  )

  return (
    <PlayerGrid>
      <NowPlaying
        artwork={currentArtwork}
        audioRef={player.audioRef}
        category={player.playbackRoutine?.category}
        currentTime={player.currentTime}
        disabled={!player.track}
        duration={player.duration}
        playing={player.playing}
        progressPercentage={player.progressPercentage}
        source={player.track?.url}
        title={
          player.track
            ? getRoutineTrackLabel(player.track.title)
            : 'Selecciona un ejercicio'
        }
        onEnded={player.handleEnded}
        onLoadedMetadata={player.handleLoadedMetadata}
        onNext={() => player.step(1)}
        onPrevious={() => player.step(-1)}
        onSeek={player.seek}
        onTimeUpdate={player.handleTimeUpdate}
        onTogglePlay={player.togglePlay}
      />
      <RoutinePlaylist
        categories={categories}
        items={playlistItems}
        onCategorySelect={player.setBrowseCategoryIndex}
        onTrackSelect={player.selectTrack}
      />
    </PlayerGrid>
  )
}

export default RoutinePlayer
